import config from 'veui/managers/config'

config.defaults({}, 'fieldset')
